import { isDianPingMerchant } from './merchants';
import { isQuickApp } from './thirdParty';
/**
 * 是否美团小程序
 * @param ua
 * @returns
 */
export const isMMP = (ua) => /(micromessenger).*(miniprogram\s+MMP)/i.test(ua);
/**
 * 是否美团App，不包括：美团小程序、快应用
 * @param ua
 * @returns
 */
export const isMeiTuan = (ua) => (/meituangroup/i.test(ua) || ua.indexOf("meituan") > -1) && (!isMMP(ua) || !isQuickApp(ua));
/**
 * 是否点评App
 * @param ua
 * @returns
 */
export const isDianPing = (ua) => !isDianPingMerchant(ua) && ua.indexOf("dianping") > -1;
/**
* 是否大象
* @param ua
* @returns
*/
export const isDaXiang = (ua) => {
    if (/xm\/\d{1,2}.\d{1,2}.\d{1,2}/.test(ua) ||
        ua.indexOf("com.meituan.message") > -1 ||
        ua.indexOf("com.meituan.xm") > -1 ||
        ua.indexOf("com.sankuai.xmpp") > -1) {
        return true;
    }
    return false;
};
/**
 * 是否大象PC侧边栏
 * @param ua
 * @returns
 */
export const isDaXiangSider = (ua) => {
    if (/DXShell/.test(ua)) {
        return true;
    }
    return false;
};
/**
 * 外卖App
 * @param ctx
 * @returns
 */
export const isWaiMaiApp = (ua, query = {}) => {
    const wmCtype = (query === null || query === void 0 ? void 0 : query.wm_ctype) || '';
    if (ua.indexOf('meituanwaimai-c') > -1 || (wmCtype === 'iphone' || wmCtype === 'android')) {
        return true;
    }
    return false;
};
/**
 * 美团众包，android 端
 * @param param0
 * @returns
 */
export const isCrowdsourceAndroid = (ua) => /com\.sankuai\.meituan\.dispatch\.crowdsource/i.test(ua);
/**
 * 美团众包，ios 端
 * @param ua
 * @returns
 */
export const isCrowdsourceIOS = (ua) => /com\.meituan\.banma\.crowdsource/i.test(ua);
/**
 * 是否美团众包
 * @param ua
 * @returns
 */
export const isCrowdsource = (ua) => isCrowdsourceAndroid(ua) || isCrowdsourceIOS(ua);
/**
 * 美团配送, android 端
 * @param ua
 * @returns
 */
export const isDeliveryAndroid = (ua) => /meituan\.dispatch\.homebrew/i.test(ua);
/**
 * 美团配送, ios 端
 * @param param0
 * @returns
 */
export const isDeliveryIOS = (ua) => /com\.meituan\.banma\.homebrew/i.test(ua);
/**
 * 是否美团配送
 * @param ua
 * @returns
 */
export const isMTDeliver = (ua) => isDeliveryAndroid(ua) || isDeliveryIOS(ua);
/**
 * 是否美团钱包
 * @param ua
 * @returns
 */
export const isConch = (ua) => ua.indexOf("conch") > -1;
/**
 * 是否猫眼电影
 * @param ua
 * @returns
 */
export const isMaoYan = (ua) => ua.indexOf("movie") > -1;
/**
 * 是否买菜App
 * @param ua
 * @returns
 */
export const isMaiCai = (ua) => /\bimaicai\b/.test(ua) || (/\bretail\.v\b/i.test(ua) && /\bmeituan\b/i.test(ua));
/**
 * 是否小象
 * @param ua
 * @returns
 */
export const isXiaoXiang = (ua) => /\biretail\b/.test(ua) || (/\bretail\b/i.test(ua) && /\bmeituan\b/i.test(ua));
/**
 * 是否为美团优选App
 * @param ua
 * @returns
 */
export const isMTYXApp = (ua) => {
    return (isMMP(ua) && ua.indexOf("meituanyouxuan_app") > -1) ||
        ua.indexOf("com.meituan.iyouxuan") > -1 ||
        ua.indexOf("com.sankuai.youxuan") > -1;
};
/**
 * 是否美团直播助手App
 * @param ua
 * @returns
 */
export const isMTLiveAnchor = (ua) => {
    return ua.indexOf('com.meituan.mliveanchor') > -1 || ua.indexOf('com.meituan.imliveanchor') > -1;
};
